<template>
  <v-list-item-content>
    <v-list-item-title 
      v-text="indent(process)"
    >
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'ProcessMenuItem',
  props: {
    process: Object,
  },
  methods: {
    indent(process) {
      var level = 1
      var tmp = process
      while (tmp.parent) {
        tmp = tmp.parent
        level++
      }
      let label = '**'.repeat(level / 2 - 1) + ' '
      return label + process.name
    },
  },
}
</script>
